import { useWindowSize } from "usehooks-ts";
import { MOBILE_BREAKPOINT } from "../../constants";

export const useIsMobile = (customWidth?: number): boolean => {
  const { width } = useWindowSize();
  return (customWidth ?? width) <= MOBILE_BREAKPOINT;
};
